require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./wob-the-dpdp-act.json") })
        }
      }, "path---wob-the-dpdp-act");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---wob-the-dpdp-act!./.cache/json/wob-the-dpdp-act.json
// module id = 1279
// module chunks = 231608221292675